import * as React from 'react';
import { useState } from 'react';
import ControlAutocomplete from 'lqa-ui/lib/Components/ControlAutocomplete/index';

interface IProps {
    // brandIds are possible preselected items
    missedStandards: {
        categoryId: number,
        standardId: number,
        actionPlanId: number
    }[];
    selected: any[];
    onChange: (newList: any[]) => void;
    disabled?: boolean;
    minChars?: number;
    className?: string;
    placeholder?: string;
    options: any;
}

export const StandardMultiSelect = (props: IProps) => {
    const { selected, onChange, disabled, className, options } = props;
    const minChars = 0;

    const [text, setText] = useState('');
    let optD: any = [];
    if (!!options) {
        const filteredOpt = options.filter(o => (o.label).toLowerCase().includes(text.toLowerCase()));
        const selectedOpt = filteredOpt.filter(o => selected.find(s => s.label === o.label));
        const notSelectedOpt = filteredOpt.filter(o => !selected.find(s => s.label === o.label));
        optD = [...selectedOpt, ...notSelectedOpt];
    }
    const optionsData = !!options
        ? optD.map((standard, i) => ({
            label: standard.label,
            subtext:  undefined,
            value: standard.standardId,
            data: standard,
            selected: selected.find(s => s.label === standard.label) ? true : false,
        }))
        : [];

    return (
        <ControlAutocomplete
            disabled={disabled}
            placeholder={props.placeholder || 'Choose standard'}
            data={optionsData}
            className={className}
            minChars={minChars}
            onChange={setText}
            onSelect={(option) => {
                if (selected.find(standard => standard.label === option.data.standardId)) {
                    return;
                }
                setText('');
                onChange([...selected, option.data]);
            }}
            value={text}
        />
    );
};
